import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { serviceIcon, serviceLabel, STATUS_LABEL, formatZAR } from "@/lib/constants";

export default function AdminScheduled() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/scheduled").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  // Group by day (YYYY-MM-DD)
  const groups = items.reduce((acc, r) => {
    const day = (r.scheduledDate || "").slice(0, 10);
    (acc[day] = acc[day] || []).push(r);
    return acc;
  }, {});
  const days = Object.keys(groups).sort();

  return (
    <div>
      <div className="px-6 pt-8 pb-4">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#3CFF7E] font-display mb-1">Admin</div>
        <h1 className="font-display text-3xl font-black tracking-tight">Scheduled Jobs</h1>
        <p className="text-sm text-[#9CA3AF] mt-1">{loading ? "Loading..." : `${items.length} upcoming / past services`}</p>
      </div>
      <div className="px-6 pb-6 space-y-4">
        {!loading && items.length === 0 && (
          <div className="border border-dashed border-white/10 rounded-md p-8 text-center text-sm text-[#9CA3AF]">
            No scheduled jobs yet.
          </div>
        )}
        {days.map((day) => (
          <section key={day}>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#E6FF3C] font-display mb-2">
              {new Date(day).toLocaleDateString("en-ZA", { weekday: "short", day: "numeric", month: "short", year: "numeric" })}
            </div>
            <div className="space-y-2">
              {groups[day].map((r) => (
                <Link key={r.id} to={`/app/request/${r.id}`} className="block border border-white/10 bg-[#111827] rounded-md p-3 hover:border-white/30">
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex items-start gap-3 flex-1 min-w-0">
                      <div className="text-2xl">{serviceIcon(r.serviceType)}</div>
                      <div className="min-w-0">
                        <div className="font-display font-bold text-sm text-white truncate">{serviceLabel(r.serviceType)}</div>
                        <div className="text-xs text-[#9CA3AF] truncate">{r.clientName} · {new Date(r.scheduledDate).toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" })}</div>
                      </div>
                    </div>
                    <div className="text-right shrink-0">
                      <span className={`status-pill status-${r.status}`}>{STATUS_LABEL[r.status]}</span>
                      <div className="font-display font-bold text-sm mt-1 text-white">{formatZAR(r.price)}</div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
